module.exports = __webpack_public_path__ + "static/media/logo_cms.cf9de90c.svg";